import { HiddenOptionsAndValues, Monogram, OptionsSelection, StylePreset, Option } from '@susu/custom-made/utils/interfaces';
import { ConfigurationTypes } from '@susu/custom-made/utils/productDefinition';
import { createContext } from 'react';

type OptionContextType = {
  selectedOptions: OptionsSelection;
  setSelectedOptions: (selectedOptions: OptionsSelection) => void;
  selectOption: (option: OptionsSelection) => void;
  selectedMonogram: Monogram;
  setSelectedMonogram: (selectedMonogram: Monogram) => void;
  addMonogram: (monogram: Monogram) => void;
  deleteMonogram: (monogramId: number) => void;
  clearMonograms: () => void;
  selectedBaseStyle: Record<string, StylePreset>;
  setSelectedBaseStyle: (selectedBaseStyle: Record<string, StylePreset>) => void;
  selectBaseStyle: (configurationType: ConfigurationTypes, baseStyle: StylePreset) => void;
  removeBaseStyle: (configurationType: ConfigurationTypes) => void;
  isAdditionalProductAdded: Record<string, boolean>;
  setIsAdditionalProductAdded: (isAdditionalProductAdded: Record<string, boolean>) => void;
  addRemoveAdditionalProduct: (configurationType: ConfigurationTypes, isAdded: boolean) => void;
  isBaseStyleSelection: boolean;
  setIsBaseStyleSelection: (isBaseStyleSelection: boolean) => void;
  selectedOption: Option | undefined;
  selectedOptionGroup: Option | undefined;
  setSelectedOption: (selectedOption: Option | undefined) => void;
  setSelectedOptionGroup: (selectedOptionGroup: Option | undefined) => void;
  animation: { status: boolean; from: Option | undefined; to: Option | undefined };
  setAnimation: (animation: { status: boolean; from: Option | undefined; to: Option | undefined }) => void;
  hiddenOptionsAndValues: HiddenOptionsAndValues;
  setHiddenOptionsAndValues: (hiddenOptionsAndValues: HiddenOptionsAndValues) => void;
  updateHiddenOptionsAndValues: (hiddenOptionsAndValues: HiddenOptionsAndValues) => void;
  isProductAddedModalShown: Record<string, boolean>;
  setIsProductAddedModalShown: (isProductAddedModalShown: Record<string, boolean>) => void;
  updateIsProductAddedModalShown: (configurationType: ConfigurationTypes, showModal: boolean) => void;
  isRemoveProductModalShown: Record<string, boolean>;
  setIsRemoveProductModalShown: (isRemoveProductModalShown: Record<string, boolean>) => void;
  updateIsRemoveProductModalShown: (configurationType: ConfigurationTypes, showModal: boolean) => void;
};

const defaultOptionContext: OptionContextType = {
  selectedOptions: {},
  setSelectedOptions: () => {},
  selectOption: () => {},
  selectedMonogram: {},
  setSelectedMonogram: () => {},
  addMonogram: () => {},
  deleteMonogram: () => {},
  clearMonograms: () => {},
  selectedBaseStyle: {},
  setSelectedBaseStyle: () => {},
  selectBaseStyle: () => {},
  removeBaseStyle: () => {},
  isAdditionalProductAdded: {},
  setIsAdditionalProductAdded: () => {},
  addRemoveAdditionalProduct: () => {},
  isBaseStyleSelection: false,
  setIsBaseStyleSelection: () => {},
  selectedOption: undefined,
  setSelectedOption: () => {},
  selectedOptionGroup: undefined,
  setSelectedOptionGroup: () => {},
  animation: { status: false, from: undefined, to: undefined },
  setAnimation: () => {},
  hiddenOptionsAndValues: {
    optionsPerConfiguration: {},
    optionValuesPerConfiguration: {},
    monogramColors: [],
    monogramPositions: [],
  },
  setHiddenOptionsAndValues: () => {},
  updateHiddenOptionsAndValues: () => {},
  isProductAddedModalShown: {},
  setIsProductAddedModalShown: () => {},
  updateIsProductAddedModalShown: () => {},
  isRemoveProductModalShown: {},
  setIsRemoveProductModalShown: () => {},
  updateIsRemoveProductModalShown: () => {},
};

export const OptionContext = createContext<OptionContextType>(defaultOptionContext);
